/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const StarFilledColoredBoldIcon = /*#__PURE__*/ createSvgIcon(
  'StarFilledColoredBoldIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M17.646 7.78l-5.456-.01-1.78-5.46a.45.45 0 00-.85 0l-1.8 5.46H2.45A.45.45 0 002 8.2a.43.43 0 00.16.35L6.66 12l-1.72 5.43a.45.45 0 00.3.56.43.43 0 00.39-.08L10 14.53l4.38 3.38a.44.44 0 00.69-.48L13.33 12l4.49-3.44a.43.43 0 00-.31-.78h.136z"
            fill="#FFC936"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.145 1.276a1.45 1.45 0 012.21.705l.003.01 1.558 4.78 4.544.008a1.43 1.43 0 01.953 2.587l-3.915 3 1.525 4.762a1.44 1.44 0 01-2.258 1.57l-3.764-2.904-3.752 2.901a1.43 1.43 0 01-1.284.256l-.008-.002-.008-.002a1.45 1.45 0 01-.966-1.805l.002-.007 1.51-4.768-3.953-3.03-.009-.008a1.43 1.43 0 01-.532-1.164v-.01a1.45 1.45 0 011.45-1.385h4.586l1.576-4.781.003-.008a1.45 1.45 0 01.53-.705zm6.748 7.5L12.19 8.77s-.002 0 0-1l-.002 1-.724-.001-1.482-4.545L8.484 8.77H4.09l3.734 2.863-1.39 4.39L10 13.266l3.569 2.754-1.406-4.386 3.73-2.858z"
            fill="#A32E00"
          />
        </>
      ),
    },
  },
  false
);

export default StarFilledColoredBoldIcon;
